import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ValidateCustomEmail } from '../../shared/validators/type-validators';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistrationErrorModel } from 'src/app/services/authentication/models/registration-error.model';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {
  recoverPasswordForm: UntypedFormGroup;
  requestChangeSuccessfully = false;

  constructor(
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.inicializarFormulario();
  }

  inicializarFormulario() {
    this.recoverPasswordForm = this.fb.group({
      email: [null, [Validators.required, ValidateCustomEmail]]
    });
  }

  onSubmit() {
    if (this.recoverPasswordForm.invalid) {
      this.recoverPasswordForm.markAllAsTouched();
      return;
    }

    this.recoverPassword();
  }

  recoverPassword() {
    this.spinner.show();

    this.authenticationService
      .requestChangePassword(this.recoverPasswordForm.get('email')?.value)
      .subscribe({
        next: () => {
          this.toastrService.success(
            'Solicitação de recuperação de senha enviada com sucesso!'
          );
          this.requestChangeSuccessfully = true;
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.status === 403) {
            const errorBody = err?.error as RegistrationErrorModel | undefined;
            if (errorBody?.errorCode === 'PROFILE_INCOMPLETE') {
              this.toastrService.warning('Seu cadastro não foi finalizado. Complete seu perfil para continuar.');
              this.router.navigate(['cadastro'], {
                queryParams: {
                  email: this.recoverPasswordForm.get('email').value,
                  completeRegister: true,
                  ignoreCpf: errorBody?.ignoreCpf ?? null
                }
              });
            } else {
              this.toastrService.warning('Seu e-mail ainda não foi verificado. Confirme o código enviado para continuar.');
              this.router.navigate(['cadastro'], {
                queryParams: { email: this.recoverPasswordForm.get('email').value }
              });
            }
          } else {
            this.toastrService.error('Não foi possível enviar o link. Tente novamente.');
          }
        }
      });
  }

}
